import { useEffect, useState } from 'react';
import PartnerPageDataService from '../services/partner-pages.service';
import { IPartnerPlanData } from '../types';

export const useDataForPlans = (
  planList: string[],
  slug: string
): IPartnerPlanData[] => {
  const [cardData, setCardData] = useState<IPartnerPlanData[]>([]);
  useEffect(() => {
    PartnerPageDataService.getPlanData(planList, slug)
      .then((data) => setCardData(data))
      .catch((err) => {
        console.error(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return cardData;
};
